import React from "react";
import { FieldGroup } from "../../../../../common/components/Form/Layout/FieldGroup";
import { useBankValidation } from "../../../hooks/use-bank-validation";
import { RoutingNumberInput } from "../../BankValidators/RoutingNumberInput";
import { RoutingNumberInputFields } from "../../BankValidators/RoutingNumberInput/constants";

export const ACHBankDetails: React.FC = () => {
  const {
    handleClear: handleBankCountryValidatedCountryClear,
    handleValidateCompleted: handleValidateRoutingCompleted,
  } = useBankValidation({
    nameField: RoutingNumberInputFields.BankName,
  });

  return (
    <FieldGroup title="Bank details">
      <RoutingNumberInput
        onClear={handleBankCountryValidatedCountryClear}
        onValidationCompleted={handleValidateRoutingCompleted}
      />
    </FieldGroup>
  );
};
